import React, { useState } from "react";
import cn from "classnames";
import styles from "./Faq.module.sass";
import Item from "./Item";
import Dropdown from "../../../components/Dropdown";

// FAQ "Tarification" pour Edutio
const items = [
  {
    title: "Tarification",
    items: [
      {
        title: "Combien coûte Edutio ?",
        answer:
          "La tarification est simple : un tarif au dossier ou à la facture. Vous payez seulement ce que vous consommez !",
      },
      {
        title: "Y a‑t‑il un tarif au volume ?",
        answer:
          "En effet, nous effectuons des devis spécifiques en fonction du nombre de dossiers et des fonctionnalités souhaitées.",
      },
      {
        title:
          "Mon école/CFA gère peu de contrats, est‑ce qu’Edutio fonctionne ?",
        answer:
          "Oui, Edutio fonctionne pour tous types d’organismes de formation ou d’écoles, peu importe le nombre de contrats que vous gérez à l’année, que ce soit pour les stages ou l’alternance. Notre solution SaaS vous offre une totale flexibilité.",
      },
      {
        title: "En combien de temps puis‑je démarrer avec Edutio ?",
        answer:
          "En 48h ! Nous effectuons l’intégration de votre centre de formation (CFA). En 2 jours, vous pouvez commencer à traiter vos dossiers et leur facturation sur notre plateforme en ligne. Elle est très simple d’utilisation et ne nécessite aucune formation ni installation de logiciel.",
      },
    ],
  },
];

const Team = () => {
  const options = [];
  items.map((x) => options.push(x.title));

  const [category, setCategory] = useState(options[0]);

  return (
    <div className={cn("section-border-top", styles.section)}>
      <div className={cn("container", styles.container)}>
        <div className={styles.top}>
          <div className={cn("stage-small", styles.stage)}>La tarification</div>
          <h2 className={cn("h2", styles.title)}>
            Tout ce que vous devez savoir sur la facturation
          </h2>
          <div className={styles.info}>
            Vous ne trouvez pas la réponse que vous cherchez ? Vous pouvez
            discuter avec nos experts ou <a href="/contact">Contactez notre support</a>
          </div>
          <div className={styles.nav}>
            {items.map((x, index) => (
              <button
                className={cn(styles.btn, {
                  [styles.active]: x.title === category,
                })}
                onClick={() => setCategory(x.title)}
                key={index}
              >
                {x.title}
              </button>
            ))}
          </div>
          <Dropdown
            className={styles.dropdown}
            value={category}
            setValue={setCategory}
            options={options}
          />
        </div>
        <div className={styles.list}>
          {items
            .find((x) => x.title === category)
            .items.map((x, index) => (
              <Item item={x} key={index} />
            ))}
        </div>
      </div>
    </div>
  );
};

export default Team;
